import { useState } from 'react'
import { friendsService } from '../services/friendsService'

export const useFriendsActions = (dataHandlers) => {
  const [loading, setLoading] = useState(false)

  const sendFriendRequest = async (userId, message, setSearchResults) => {
    setLoading(true)
    try {
      await friendsService.sendFriendRequest(userId, message)
      setSearchResults(prev => prev.map(user =>
        user._id === userId ? { ...user, friendshipStatus: 'pending' } : user
      ))
      dataHandlers.loadSentRequests()
      return { success: true, message: 'Friend request sent successfully!' }
    } catch (error) {
      if (process.env.NODE_ENV === 'development') console.error('Error sending friend request:', error)
      return { success: false, error: 'Failed to send friend request' }
    } finally {
      setLoading(false)
    }
  }

  const acceptRequest = async (friendshipId) => {
    setLoading(true)
    try {
      await friendsService.acceptFriendRequest(friendshipId)
      dataHandlers.loadFriendRequests()
      dataHandlers.loadFriends()
      return { success: true, message: 'Friend request accepted!' }
    } catch (error) {
      if (process.env.NODE_ENV === 'development') console.error('Error accepting friend request:', error)
      return { success: false, error: 'Failed to accept friend request' }
    } finally {
      setLoading(false)
    }
  }

  const declineRequest = async (friendshipId) => {
    setLoading(true)
    try {
      await friendsService.declineFriendRequest(friendshipId)
      dataHandlers.loadFriendRequests()
      return { success: true, message: 'Friend request declined' }
    } catch (error) {
      if (process.env.NODE_ENV === 'development') console.error('Error declining friend request:', error)
      return { success: false, error: 'Failed to decline friend request' }
    } finally {
      setLoading(false)
    }
  }

  const removeFriend = async (friendId) => {
    setLoading(true)
    try {
      await friendsService.removeFriend(friendId)
      dataHandlers.loadFriends()
      return { success: true, message: 'Friend removed successfully' }
    } catch (error) {
      if (process.env.NODE_ENV === 'development') console.error('Error removing friend:', error)
      return { success: false, error: 'Failed to remove friend' }
    } finally {
      setLoading(false)
    }
  }

  return {
    loading,
    sendFriendRequest,
    acceptRequest,
    declineRequest,
    removeFriend
  }
}